import { render, staticRenderFns } from "./DailyActivityStatisticsPage.vue?vue&type=template&id=7ba915ca&scoped=true&"
import script from "./DailyActivityStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./DailyActivityStatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba915ca",
  null
  
)

export default component.exports